import React from "react";
import { Route, Redirect } from "react-router-dom";
import { toast } from 'react-toastify';

const PrivateRoute = ({ component: Component, commonProps, ...rest }) => {
    const userData = localStorage.getItem('ced:user-info')
    const user = userData ? JSON.parse(userData) : null;
    // console.log('PrivateRoute', user)
    return (
        <Route
            {...rest}
            render={(props) =>
                user ? <Component {...commonProps} {...props} />
                    : redirectToLogin(props)
            }
        />
    );
}


function redirectToLogin(props) {
  const historyUrl = window.location.href.replace(window.location.origin, "");
  sessionStorage.setItem('ced:previousUrl', historyUrl);
  toast.info(`Bạn cần đăng nhập để truy cập trang này`, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "colored",
    className: 'toast-info-container',
  });
  return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
}


// const PrivateRoute = ({ children }) => {
//     const user = useAuth();
//     console.log('vao dayyy')
//     if (!user) {
//         // user is not authenticated
//         return <Redirect to="/login" />;
//     }
//     return children;
// }
export default PrivateRoute;
